import defaultInsightsColumnState, { customColumnStatesMapping } from '@/modules/reporting/insightsColumnState';
import { combineSortModelToColumnStateForNewAgGrid } from '@/modules/reporting/components/AgGridUtils';

export default class CannedReportsService {
  /** @ngInject **/
  constructor() {
    this.defaultColumnStateMapping = defaultInsightsColumnState.reduce(
      (columnMapping, column) => {
        columnMapping[column.colId] = column;

        return columnMapping;
      },
      {}
    );
  }

  getColumnState(columnsOrder, sortOrder) {
    const autoGroupColumnState = defaultInsightsColumnState[0];

    let columns = columnsOrder.map(column => {
      let columnObject = this.defaultColumnStateMapping[column] || customColumnStatesMapping[column];
      
      return {
        ...columnObject,
        colId: column
      };
    });

    columns.splice(0, 0, autoGroupColumnState);

    columns = combineSortModelToColumnStateForNewAgGrid(sortOrder, columns);

    return columns;
  }
}
